import { FC } from 'react';
import { Routes, Route } from 'react-router-dom';
import { Box } from '@chakra-ui/react';
import AnswerAssessmentPage from './profile/answer-asssesment-page';
import AnswerAssessmentThanks from './profile/answer-assessment-thanks';
import CapturePage from './leads/capture-page';

const App: FC = () => {
  return (
    <Box minH="100vh" bg="gray.50">
      <Routes>
        {/* <Route path="/" element={<NotFoundPage />} /> */}
        <Route path="/profile/:hash" element={<AnswerAssessmentPage />} />
        <Route path="/profile/:hash/thanks" element={<AnswerAssessmentThanks />} />
        <Route path="/avaliacao/:hash" element={<AnswerAssessmentPage />} />
        <Route path="/avaliacao/:hash/obrigado" element={<AnswerAssessmentThanks />} />
        <Route path="/campaign/:code" element={<CapturePage />} />
      </Routes>
    </Box>
  );
};

export default App; 